const cartCount = document.querySelector('[data-cart-count]') ?? false;
const cartIcon = document.querySelector('[data-cart-icon]') ?? false;

const updateCartCount = () => {
  if (!cartCount) {
    return;
  }

  fetch(`${window.Shopify.routes.root}cart.js`)
    .then(response => response.json())
    .then(data => {
      cartCount.innerHTML = data.item_count;

      if (data.item_count > 0) {
        cartIcon.classList.remove('fill-transparent');
        cartIcon.classList.add('fill-brand-yellow');
      } else {
        cartIcon.classList.remove('fill-brand-yellow');
        cartIcon.classList.add('fill-transparent');
      }
    });
};

export default updateCartCount;
